import { React, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import logo from "../../assets/img/logo-nanny.png";
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { clearSignupData, signupUser } from '../../store/apiSlice/Signupnannyslice';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-input-2';
import { ClipLoader } from "react-spinners";
import { capitalizeFirstLetter } from '../../utils/help';

import PlaceSearch from "../map/Googlemap";

const Signupnanny = () => {

    const dispatch = useDispatch();
    const data = useSelector((state) => state.rootReducer.signUp.data);
    const isLoading = useSelector((state) => state.rootReducer.signUp.loading);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [firstName, setfirstName] = useState('');
    const [lastName, setlastName] = useState('');
    const [mobileNumber, setmobileNumber] = useState('');
    const [experienceOfYears, setexperienceOfYears] = useState('');
    const [postalCode, setpostalCode] = useState('');
    const [address, setaddress] = useState('');
    const [country, setCountry] = useState('34');
    const [education, setEducation] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [about, setAbout] = useState('')

    const [showMap, setShowMap] = useState(false);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [error, setError] = useState(null);
    const [editedApt, setEditedApt] = useState('');
    const [editedHouse, setEditedHouse] = useState('');
    const [editedStreet, setEditedStreet] = useState('');

    useEffect(() => {
        if (!showMap) return;

        if (!navigator.geolocation) {
            setError("Geolocation not supported");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            ({ coords }) => {
                setLatitude(coords.latitude);
                setLongitude(coords.longitude);
                setError(null);
            },
            (err) => {
                setError(err.message);
                setLatitude(null);
                setLongitude(null);
            }
        );
    }, [showMap]);


    const handleOnChange = (value, country) => {
        setCountry(value);
    };

    const handleSignup = () => {
        const payload = {
            email: email,
            password: password,
            firstName: capitalizeFirstLetter(firstName),
            lastName: capitalizeFirstLetter(lastName),
            countryCode: `+${country}`,
            mobileNumber: mobileNumber,
            referralCode: "",
            dateOfBirth: "",
            experienceOfYears: experienceOfYears,
            country: "sds",
            pinCode: postalCode,
            postalCode: postalCode,
            address: address,
            latitude,
            longitude,
            type: 1,
            education: education,
            about: about,
            description: about
        }
        const requiredFields = {
            email: "email",
            password: "password",
            firstName: "firstName",
            lastName: "lastName",
            mobileNumber: "mobileNumber",
            experienceOfYears: "experienceOfYears",
            address: "address",
            postalCode: "postalCode",
            education: "education",
            about: 'about'
        };

        const missingFields = Object.keys(requiredFields).filter((key) => !payload[key]);

        if (missingFields.length > 0) {
            alert(`Please provide required fields: ${missingFields.join(", ")}`);
            return
        }

        try {
            dispatch(signupUser(payload));
        } catch (error) {
            console.error('signup failed:', error);
        }
    };


    const navigate = useNavigate();

    const navigateToAnotherScreen = () => {
        // navigate('/otp');
        navigate('/otp', {
            state: {
                email: email,
                source: 'signup'
            }
        });
    }

    useEffect(() => {
        if (data != null && data.status === 1) {
            navigateToAnotherScreen();
        }
        else if (data != null) {
            alert(data.message)
            dispatch(clearSignupData())
        }
    }, [data])

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
        }
        else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            /* you can also use 'auto' behaviour 
               in place of 'smooth' */
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="container py-5">

                    <a href="#" className="custom-logo d-block login-logo mx-auto">
                        <img className="mw-100" src={logo} alt="logo" />
                    </a>

                    <div className="row">
                        <div className="col-lg-6 offset-lg-3 offset-sm-1 col-sm-10">
                            <div className="login-container">
                                <form className="login-form" appearance="outline">
                                    <h3>Welcome</h3>
                                    <p>Please Signup as {`${window.location.pathname.split('/')[1] === 'signupnanny' ? "Nanny" : "Family"}`}</p>

                                    <div className='tab-selector' style={{ display: 'flex', gap: "1rem", marginBottom: '2rem', alignItems: 'center' }}>
                                        <button
                                            type='button'
                                            style={{ width: "100%" }}
                                            onClick={() => { scrollToTop(); navigate('/signupnanny') }}
                                            className={`btn tab-btn ${window.location.pathname.split('/')[1] === 'signupnanny' ? 'active' : ''}`}
                                        >
                                            Register as Nanny
                                        </button>
                                        <button
                                            style={{ width: "100%" }}
                                            type='button'
                                            onClick={() => { scrollToTop(); navigate('/signupfamily') }}
                                            className={`btn tab-btn ${window.location.pathname.split('/')[1] === 'signupfamily' ? 'active' : ''}`}
                                        >
                                            Register as Family
                                        </button>
                                    </div>

                                    <div className='input-group input_width'>
                                        <input type="text" placeholder="First name" value={firstName} onChange={(e) => setfirstName(e.target.value)} style={{ width: "49%", }} />
                                        <input type="text" placeholder="Last name" value={lastName} onChange={(e) => setlastName(e.target.value)} style={{ width: "49%" }} />
                                    </div>

                                    <div className='btn_flex mb-3'>
                                        <PhoneInput
                                            inputClass={"inputt-ph"}
                                            containerStyle={{}}
                                            searchClass="search-class"
                                            disableSearchIcon={false}
                                            enableTerritories
                                            countryCodeEditable={false}
                                            defaultCountry="ES"
                                            placeholder='Phone number'
                                            buttonStyle={{ width: '47px' }}
                                            dropdownStyle={{ height: '150px' }}
                                            enableSearch={true}
                                            value={country}
                                            onChange={handleOnChange}
                                            inputProps={{
                                                readOnly: true, // This makes the input read-only
                                            }}
                                            enableAreaCodeStretch
                                        />
                                        <input type='number' className='mobilenumber' value={mobileNumber} onChange={(e) => setmobileNumber(e.target.value)} />
                                    </div>

                                    <div className='input-group'>
                                        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>

                                    <div className='input-group'>
                                        {/* <input type="text" placeholder="Address" value={address} onChange={(e) => setaddress(e.target.value)} /> */}
                                        <input
                                            type="text"
                                            placeholder="Address"
                                            value={address}
                                            readOnly
                                            onClick={() => setShowMap(true)}
                                            style={{ cursor: "pointer", backgroundColor: "#fdfdfd" }}
                                        />

                                    </div>

                                    <div className='input-group'>
                                        <input type="number" placeholder="Postal code" value={postalCode} onChange={(e) => setpostalCode(e.target.value)} />
                                    </div>

                                    <div className='input-group'>
                                        <input type="number" placeholder="Experience of years" value={experienceOfYears} onChange={(e) => setexperienceOfYears(e.target.value)} />
                                    </div>

                                    <div className='input-group'>
                                        <input
                                            type="text"
                                            placeholder="Education"
                                            id="education"
                                            onChange={(e) => setEducation(e.target.value)}
                                            value={education}
                                        />
                                    </div>

                                    <div className='input-group'>
                                        {/* <input
                                            type="text"
                                            placeholder="about"
                                            id="about"
                                            onChange={(e) => setAbout(e.target.value)}
                                            value={about}
                                        /> */}
                                        <textarea
                                            placeholder="Please write at least five sentences about who you are and your experience working with children."
                                            id="about"
                                            onChange={(e) => setAbout(e.target.value)}
                                            value={about}
                                            style={{ height: "100px", resize: "vertical" }} // you can adjust height
                                        />

                                    </div>

                                    <div className="input-group">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            id="password"
                                            placeholder="Password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleSignup();
                                                }
                                            }}
                                        />

                                        <span
                                            className="position-absolute end-0 top-50 translate-middle-y me-3"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? (
                                                <i className="fa fa-eye-slash" style={{ color: "#89d6ce" }}></i>
                                            ) : (
                                                <i className="fa fa-eye" style={{ color: "#89d6ce" }}></i>
                                            )}
                                        </span>
                                    </div>

                                    <Button type='button' onClick={() => handleSignup()}>
                                        {isLoading ? (
                                            <ClipLoader color="#fff" size={16} />
                                        ) : (
                                            "Register"
                                        )}
                                    </Button>

                                    {/* <div className='bottom-text'>
                                        <div className="mt-3 bottom_link">Im a new user.
                                            <div className='flex_link'>
                                                <p className='link_color' onClick={() => { scrollToTop(); navigate('/signupnanny') }} > {" "}REGISTER AS NANNY</p>
                                                <span className='mx-1'> / </span>
                                                <p className='link_color' onClick={() => { scrollToTop(); navigate('/signupfamily') }}>REGISTER AS FAMILY</p>
                                            </div>
                                        </div>
                                    </div> */}

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            <Modal show={showMap} onHide={() => setShowMap(false)} className="add_detalis">
                <Modal.Header closeButton>
                    <Modal.Title>Select Address</Modal.Title>
                </Modal.Header>

                <div style={{ paddingBottom: 20 }}>
                    {error && <p>Error: {error}</p>}

                    {latitude && longitude && (
                        <PlaceSearch
                            lat={latitude}
                            lng={longitude}
                            setAddress={setaddress}
                            setLatitude={setLatitude}
                            setLongitude={setLongitude}
                            setEditedApt={setEditedApt}
                            setEditedHouse={setEditedHouse}
                            setEditedStreet={setEditedStreet}
                        />
                    )}

                    <div style={{ textAlign: "center" }}>
                        <Button onClick={() => setShowMap(false)}>OK</Button>
                    </div>
                </div>
            </Modal>



        </div >
    )
}

export default Signupnanny
